import { PROFILE } from "../../data/portfolio";
import { Green } from "./Primitives";

export default function BootBanner() {
  return (
    <pre className="text-[#CCFB4B] leading-[1.1] text-[9px] xs:text-[11px] sm:text-[20px] whitespace-pre overflow-visible">
{String.raw`██████╗   █████╗  ██████╗ ██╗   ██╗
██╔══██╗ ██╔══██╗ ██╔══██╗██║   ██║
██████╔╝ ███████║ ██║  ██║██║   ██║
██╔══██╗ ██╔══██║ ██║  ██║██║   ██║
██████╔╝ ██║  ██║ ██████╔╝╚██████╔╝
╚═════╝  ╚═╝  ╚═╝ ╚═════╝  ╚═════╝ `}
      <span className="block mt-2 text-neutral-400 text-[12px] sm:text-[13px]">
        {PROFILE.name} — {PROFILE.role}
      </span>
      <span className="block text-neutral-600 text-[12px] sm:text-[13px]">
        Type <Green>help</Green> to see available commands.
      </span>
    </pre>
  );
}